import React from 'react';
import {
  ClipLoader,
  CircleLoader,
  GridLoader,
  PuffLoader,
  BeatLoader,
  BounceLoader,
  BarLoader,
  HashLoader,
  RingLoader,
  ScaleLoader,
  SyncLoader,
  MoonLoader,
  DotLoader,
  SkewLoader,
  RotateLoader,
  ClimbingBoxLoader,
} from 'react-spinners'; // Removed unavailable loaders
import '../Customloader/Customloader.css'; // Custom CSS for the loader page

const Customloader = ({
  type = 'ClipLoader',
  loading,
  size = 50,
  color = "#123abc", // Default color
}) => {
  // Define all loader types
  const loaderTypes = {
    ClipLoader: <ClipLoader size={size} color={color} loading={loading} />,
    CircleLoader: <CircleLoader size={size * 1.6} color={color} loading={loading} />,
    GridLoader: <GridLoader size={size * 0.4} color={color} loading={loading} />,
    PuffLoader: <PuffLoader size={size * 1.2} color={color} loading={loading} />,
    BeatLoader: <BeatLoader size={size * 0.3} color={color} loading={loading} />,
    BounceLoader: <BounceLoader size={size} color={color} loading={loading} />,
    BarLoader: <BarLoader width={size * 2} color={color} loading={loading} />,
    HashLoader: <HashLoader size={size} color={color} loading={loading} />,
    RingLoader: <RingLoader size={size * 1.4} color={color} loading={loading} />,
    ScaleLoader: <ScaleLoader height={size * 1.2} color={color} loading={loading} />,
    SyncLoader: <SyncLoader size={size * 0.3} color={color} loading={loading} />,
    MoonLoader: <MoonLoader size={size} color={color} loading={loading} />,
    DotLoader: <DotLoader size={size} color={color} loading={loading} />,
    SkewLoader: <SkewLoader size={size * 0.4} color={color} loading={loading} />,
    RotateLoader: <RotateLoader size={size * 0.3} color={color} loading={loading} />,
    ClimbingBoxLoader: <ClimbingBoxLoader size={size} color={color} loading={loading} />,
  };

  return (
    <div className="loader-container">
      {loaderTypes[type] || loaderTypes.ClipLoader}
    </div>
  );
};

export default Customloader;
